<template>
  <div class="container">
      <v-server-table class="table-borderless text-nowrap" :columns="columns" :options="dtOptions" @row-click="select">
      </v-server-table>
  </div>
</template>

<script>
import { NextApiClient } from '@3cad/nextcore'
import { bus } from '@store/dau'

export default {
    props: {
        service: { type: String, required: true },
        func: { type: String, required: true },
        columns: { type: Array, required: true },
        sortable: { type: Array, default() { return [] } },
        extraParams: { type: Object, default: () => { return {} } },
    },
    data () {
        return {
            dtOptions: {
                requestFunction: async data => {
                    return new Promise((resolve, reject) => {
                        let params = Object.assign({}, data, this.extraParams)
                        if(!params.orderBy)
                            params.orderBy = ''
                        NextApiClient.com(this.service, this.func, params, resolve, reject)
                    })
                },
                headings: {},
                perPage: 10,
                perPageValues: [5, 10, 25, 50],
                skin: "table datatable dataTable",
                debounce: 1000,
                /*orderBy: {
                    column: this.orderBy,
                    ascending: false
                },*/
                sortable: this.sortable,
                sortIcon: {
                    base: "ni",
                    up: "ni-arrow-up",
                    down: "ni-arrow-down"
                },
                texts: {
                    count: "Showing {from} to {to} of {count} records|{count} records|One record",
                    first: this._trans("First"),
                    last: this._trans("Last"),
                    filter: this._trans("Filter:"),
                    filterPlaceholder: this._trans("Search query"),
                    limit: this._trans("Records:"),
                    page: this._trans("Page:"),
                    noResults: this._trans("No matching records"),
                    filterBy: "Filter by {column}",
                    loading: this._trans("Loading..."),
                    defaultOption: "Select {column}",
                    columns: this._trans("Columns")
                }
            }
        }
    },
    computed: {
        preferences () {
            return this.$store.getters['getPreferences']
        }
    },
    methods: {
        select({row}) {
            this.$emit('select', row)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/_eng/globals/dDataTable.vue